<template>
	<div>
		<el-dialog
		  title="文章录入"
		  :visible.sync="articleEntryDialogVisible"
		  width="60%"
		  >
		  <div class="wrap">
		  	<el-form ref="form" :model="form" label-width="80px" :rules="rules" class="wrap-from"  >
		  		<el-form-item label="录入方式">
		  			<el-radio-group v-model="form.docType">
		  				<!-- <el-radio label="pdf">上传文件</el-radio> -->
		  				<el-radio label="md">富文本</el-radio>
		  			</el-radio-group>
		  		</el-form-item>
		  		<el-form-item label="文件"  v-if="form.docType=='pdf'">
		  			<el-upload drag class="upload-demo" ref="upload" action="#" name="files" :show-file-list="false"
		  				:auto-upload="false" :file-list="fileList" :on-change="handleChange">
		  				<div v-if="fileList.length==0">
		  					<i class="el-icon-upload"></i>
		  					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
		  				</div>
		  				<div v-else>
		  					<i class="el-icon-document"></i>
		  					<div class="el-upload__text">{{fileList[0].name}}</div>
		  				</div>
		  			</el-upload>
		  		</el-form-item>
				<el-form-item label="编写内容"  v-if="form.docType=='md'">
					<el-link icon="el-icon-edit" @click="toEditArtical">编辑</el-link>
				</el-form-item>
		  		<el-form-item label="标题" prop="docTitle">
		  			<el-input v-model="form.docTitle" placeholder="请输入标题" clearable required></el-input>
		  		</el-form-item>
		  		<el-form-item label="首图">
		  			<el-upload class="avatar-uploader" action="#" :show-file-list="false"
		  				:http-request="uploadHttpRequest">
		  				<div class="el-upload">
		  					<img v-if="form.docImg" :src="form.docImg | imagesrc" class="firstImg">
		  					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		  				</div>
		  			</el-upload>
		  		</el-form-item>
		  		<el-form-item label="简介">
		  			<el-input v-model="form.docIntroduction" placeholder="请输入简介" type="textarea" clearable autosize :rows="2">
		  			</el-input>
		  		</el-form-item>
		  		<el-form-item label="标签">
		  			<div class="tag">
		  				<el-tag type="info" size="small" :key="index" v-for="(tag,index) in form.docTags" closable
		  					:disable-transitions="false" @close="handleClose(tag)">
		  					{{tag}}
		  				</el-tag>
		  				<el-input size="mini" class="input-new-tag" v-if="inputVisible" v-model="inputValue"
		  					ref="saveTagInput" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
		  				</el-input>
		  				<el-button v-else size="small" @click="showInput" type="text">+ 添加新标签</el-button>
		  			</div>
		  
		  		</el-form-item>
		  		<el-form-item label="文章来源" prop="sourceUrl">
		  			<el-input v-model="form.sourceUrl" placeholder="请输入文章标签" clearable required
		  				:disabled="docId?true:false"></el-input>
		  		</el-form-item>
		  		<el-form-item label="作者" prop="author">
		  			<el-input v-model="form.author" placeholder="请输入作者" clearable required></el-input>
		  		</el-form-item>
		  		<el-form-item label="文章语言">
		  			<el-radio-group v-model="form.language">
		  				<el-radio label="zh">中文</el-radio>
		  				<el-radio label="en">英文</el-radio>
		  			</el-radio-group>
		  		</el-form-item>
		  		<el-form-item label="收费模式">
		  			<el-radio v-model="form.docVip" label="1">免费</el-radio>
		  			<el-radio v-model="form.docVip" label="2">会员</el-radio>
		  			<el-radio v-model="form.docVip" label="3">隐藏文章</el-radio>
		  		</el-form-item>
				<el-form-item label="选择频道" prop="channelIds" v-if="docId?false:true">
					<el-checkbox-group v-model="form.channelIds" >
						<span v-for="item in channel" :key="item.id" class="tooltip">
							<el-tooltip class="item" effect="dark" placement="top-start" >
								 <div slot="content">
									 <span v-for="(v,i) in item.descriptionArry" :key="i">
										 {{v}}<br/>
									 </span>
								 </div>
							    <el-checkbox  :label="item.id" >
							    	 {{item.name}}
							    </el-checkbox>
							</el-tooltip>
						</span>
					</el-checkbox-group>
				</el-form-item>
		  		<el-form-item label="创建单位" prop="createUnit">
		  			<el-input v-model="form.createUnit" placeholder="请输入创建单位" clearable required disabled></el-input>
		  		</el-form-item>
		  		<el-form-item label="文章时间" prop="startTime">
		  			<el-date-picker default-time="2023-05-10 15:51:43" :picker-options="pickerOptions"
		  				v-model="form.startTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"
		  				clearable required>
		  			</el-date-picker>
		  		</el-form-item>
		  	</el-form>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="articleEntryDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="submitEntryInfo" :loading="loading">{{loading?"提交中":"确定"}}</el-button>
		  </span>
		</el-dialog>
		<articleEdit ref="articleEdit" @contentParams="contentParams"></articleEdit>
	</div>
</template>

<script>
	import {
		Base64
	} from 'js-base64'
	import turndown from "turndown"; //html转markdown
	import {
		baseImg
	} from "@/common/global.js";
	import {
		uploadDocImg,
		articleEntryPdf,
		articleEntryMd,
		editUpdateFile,
		selectAllList
	} from "@/network/mochaItom/index.js"
	import {
		articeDetails
	} from "@/network/content/artice";
	import common from '@/common/common.js';
	import articleEdit from "./articleEdit"
	export default {
		name: "articleEntry",
		components:{
			articleEdit
		},
		data() {
			return {
				channel:[],
				fileList: [], //上传的文件列表
				isCheck: false,
				loading: false,
				height: '',
				turndownService: null,
				transHtml: "",
				// 表单的参数
				form: {
					docTitle: "",
					docImg: "",
					docIntroduction: "",
					docTags: [],
					sourceUrl: "",
					language: "en",
					author: "",
					createUnit: "北京信安天途科技有限公司",
					startTime: "",
					docVip: '1',
					docType: "md",
					channelIds:[],
				},
				rules: {
					docTitle: [{
						required: true,
						message: '请输入文章标题',
						trigger: 'blur'
					}],
					author: [{
						required: true,
						message: '请输入文章作者',
						trigger: 'blur'
					}],
					createUnit: [{
						required: true,
						message: '请输入创建单位',
						trigger: 'blur'
					}],
					sourceUrl: [{
						required: true,
						message: '请输入文章来源',
						trigger: 'blur'
					}],
					startTime: [{
						required: true,
						message: '请选择日期',
						trigger: 'blur'
					}],
					channelIds: [{
						required: true,
						message: '请选择频道',
						trigger: 'change'
					}],
				},
				operFormArr: [{
						name: "roleName",
						label: "角色名称",
						defaultText: "请输入角色名称",
					},
					{
						name: "role",
						label: "英文名称",
						defaultText: "请输入英文名称",
					},
				],
				imgType: 1, //1首图，2文章内部的图
				inputVisible: false,
				inputValue: "",
				loading: false,
				mContent: "",
				//禁止选今天以后的日期
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				docId: "" ,//文章id，修改的时候需要，
				articleEntryDialogVisible:false,
				html:"",
				md:"",
				docType:""
			}
		},
		computed: {
			
		},
		filters: {
			imagesrc(src) {
				return baseImg + src;
			}
		},
		methods: {
			getSelectAllList(){ //获取全部频道
				selectAllList().then(res=>{
					if (res.data.code == 200) {
						res.data.data.forEach(res=>{
							let description = res.description;
							let descriptionArry = [];
							let length = description.length;
							let num = 20;
							if(length>0){
								length = Math.ceil(length/num);
								for(let i =0;i<length;i++){
									descriptionArry.push(res.description.substr(i*num,num))
								}
							}
							res.descriptionArry = descriptionArry;
						})
						this.channel = res.data.data;
					}
				})
			},
			getInitData(){
				if (this.docId) { //编辑
					this.getActDetail()
				}else{
					this.form = this.$options.data().form // 重置data中的 某个form表单
					this.md = '';this.html = ''
					this.fileList = [];
					this.getNewTime(); //调用子组件方法，获取当前时间
				}
				this.getSelectAllList()
			},
			getActDetail() { //编辑-获取详情
				articeDetails({docId: this.docId}).then((res) => {
					if (res.data.code == 200) {
						const {docTitle,docImg,docIntroduction,list: docTags,sourceUrl,language,author,createUnit,startTime,html,md,docVip,transHtml,transMd,docType} = res.data.data
						this.form = {docTitle,docImg,docIntroduction,docTags,sourceUrl,language,author,createUnit,startTime,docVip,docType}
						if (this.form.docType != 'pdf') {
							this.md = md;this.html = html
						}else{
							this.form.pdfUrl = pdfUrl;
						};
						this.docType = docType;
						this.form.channelIds = [];
					}
				}).catch((err) => {});
			},
			uploadHttpRequest(param) { //上传图片
				const formData = new FormData();
				formData.append('file', param.file);
				formData.append('type', this.imgType);
				uploadDocImg(formData).then(res => {
					if (res.data.code == 200) {
						this.form.docImg = res.data.data;
					}
				})
			},
			//录入文章
			submitEntryInfo() {
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						this.loading = true
						// 将tag数组处理为字段串
						const docTags = this.form.docTags.join(',');
						var param = {...this.form,docTags};
						let formData = new FormData();
						let formDataPdf = new FormData();
						if (this.docId) { //编辑
							param.docId = this.docId;
							if (this.form.docType == 'pdf') {
								formDataPdf.append('docId', this.docId)
								if (this.fileList.length == 0&&this.docType=='md') { //原数据是md，改成附件，需要上传文件
									this.$message('请上传附件');
									this.loading = false
									return
								}
								if (this.fileList.length>0){
									this.fileList.forEach(item => {
										formDataPdf.append('file', item.raw)
									})
									let {data} = await editUpdateFile(formDataPdf); //上传文件
									param.pdfUrl = data.data;
									
								}
								
							} else {
								if (this.html == '' && this.md == '') {
									this.$message('文章内容不能为空');
									this.loading = false
									return
								}
								param.html = Base64.encode(this.html);
								param.md = Base64.encode(this.md);
							}
							formData.append('docCollect', JSON.stringify(param))
							var { data } = await articleEntryMd(formData);
						} else { //添加
							param.html = Base64.encode(this.html);
							param.md = Base64.encode(this.md);
							formData.append('docCollect', JSON.stringify(param))              
							if (this.form.docType == 'pdf') {
								if (this.fileList.length == 0) {
									this.$message('请上传附件');
									this.loading = false
									return
								}
								this.fileList.forEach(item => {
									formData.append('file', item.raw)
								})
								var { data } = await  articleEntryPdf(formData);
							} else {
								if (this.html == '' && this.md == '') {
									this.$message('文章内容不能为空');
									this.loading = false  
									return
								}
								var { data } = await  articleEntryMd(formData);
							}
						}
						if (data.code == 200) {
						  this.loading = false;
						  this.$message.success('录入成功');
						  this.$parent.getInitData();//刷新列表数据
						  this.articleEntryDialogVisible = false
						}else{
							this.loading = false;
						}

					} else {
						return false
					}
				}); //表单验证
			},
			// 添加tag
			handleClose(tag) {
				this.form.docTags.splice(this.form.docTags.indexOf(tag), 1);
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.form.docTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			getNewTime() {
				this.form.startTime = common._getNowTime()
			},
			handleChange(file, fileList) {
				this.fileList = [file]
			},
			toEditArtical(){
				this.$refs.articleEdit._data.articleEditDialogVisible = true;
				this.$refs.articleEdit._data.mContent = this.md;
				this.$refs.articleEdit._data.transHtml = this.html;
			},
			contentParams(data){
				this.html = data.html;
				this.md = data.md;
			},
			
		}
	}
</script>
<style scoped="scoped" lang="scss">
	.wrap {
		padding-right: 20px;
		box-sizing: border-box;
		.wrap-from{
			height: 500px;
		}
		height: 500px;
		overflow-y: scroll;
	}
	.el-icon-document{
		font-size: 50px;
		color: #C0C4CC;
		margin-top: 60px;
		line-height: 20px;
	}
	.tag {
	    padding: 5px;
	    background-color: #f9fbfc;
	    max-height: 150px;
	    overflow-y: auto;
	    .el-tag {
	        margin: 0 3px;
	    }
	}
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		display: flex;
	}
	.avatar-uploader .el-upload:hover {
	    border-color: #409eff;
	}
	.avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 150px;
	    height: 150px;
	    line-height: 150px;
	    text-align: center;
	}
	.firstImg{
		width: 200px;
	}
	::v-deep .tooltip .el-checkbox:last-of-type{
		margin-right: 15px;
	}
	.el-upload__text{
		display: block;
		width: 90%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-left: 5%;
	}
</style>
